import { post } from 'services/http';

const queryVql = (id, vql) => {
  return post(`/studio/api/knowledge-graphs/${encodeURIComponent(id)}/query-vql`, vql);
};

export default {
  queryVql
};
